// [12, 14, 16, 18, 20, 24, 32, 42, 68]
export default {
  largestTitle: 68,
  largeTitle: 42,
  title: 32,
  smallTitle: 24,
  smallestTitle: 20,
  large: 18,
  default: 16,
  body: 16,
  small: 14,
  smallest: 12,
};
